import {type FunctionalComponent, h} from '@stencil/core';
import type { EcommerceSe } from '../../types/newProductCard.type';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';

export interface ECommerceSection {
  labelProvider: labelProviderInterface;
  isEcommerceMode: boolean;
  eCommerceData: EcommerceSe;
  isGridView: boolean;
  isDashboardView: boolean;
}

export const ECommerceSection: FunctionalComponent<ECommerceSection> = (
  props
) => {
    const {
      labelProvider,
      isEcommerceMode,
      eCommerceData,
    } = props;

    return (
      isEcommerceMode && eCommerceData.availibility && eCommerceData.eShopUrl && (
        <section>
          <div class="e-commerce-section">
            <section class="e-commerce-section-cta">
              <qds-button
                data-card-area="eshop_link"
                importance="standard"
                size="standard"
                text={labelProvider('result.product.view-on-eshop', 'View On Eshop')}
                href={eCommerceData.eShopUrl}
                target='_blank'
                class="e-commerce-section-cta__button">
              </qds-button>
            </section>
          </div>
        </section>
      )
    );
};
